import { render, staticRenderFns } from "./StaffAnalysis.vue?vue&type=template&id=77031d5f&scoped=true&"
import script from "./StaffAnalysis.vue?vue&type=script&lang=js&"
export * from "./StaffAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./StaffAnalysis.vue?vue&type=style&index=0&id=77031d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77031d5f",
  null
  
)

export default component.exports